import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';



import { SiteMapComponent } from '../site-map/site-map.component';

import { DbSupervOverviewComponent } from '../../dashboard/db-superv-overview/db-superv-overview.component';
import { DashboardService } from '../../services/dashboard.service';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';
import { Site,Supervision } from 'solar-bo';
import { SiteEditComponent } from '../site-edit/site-edit.component';

@Component({
  selector: 'app-sitemain',
  templateUrl: './sitemain.component.html'
  ,styleUrls: ['./sitemain.component.scss']
})
export class SiteMainComponent extends SolarBaseComponent implements OnInit {


  site: Site;
  siteStats:any;
  /**
   * use this id to load the component using the input otherwise use route id
   */
  @Input() siteId="-1";
  @ViewChild('editform') editform: SiteEditComponent;
  @ViewChild('sitemap') sitemap: SiteMapComponent;
  @ViewChild('dashboard') dashboard: DbSupervOverviewComponent;
  //option 
  mapVisible = false;
  map3dVisible = false;
  dashboardVisible=false;
  supervisions:any[]=[];
  

  constructor(public route: ActivatedRoute) {
    super();
    let s={name:"superv1"};
    this.supervisions.push(s);
  }


  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id');
    if (!id){
      id=this.siteId;
    }
    this.getViewModel(id);
    /*     this.route.params.subscribe(
          params => {
            const id = +params['id'];
            this.getViewModel(id);   // <- Or whatever you need to do here
          }
        ); */
  }

  getViewModel(id:string, forceRefresh: boolean = false ): void {
    this.loading = true;
    this.solarService.siteGetById(id,forceRefresh)
      .subscribe(resmodel => this.handleresult(resmodel)
        , err => this.handleError(err)
      );
  }
  handleresult(resmodel: any) {
    this.loading = false;
    this.site = resmodel;
    this.configure3D(this.site);

    this.siteStats= DashboardService.calculateSiteStats(this.site);
  }

  refresh() {
    let id=null;
    if (this.siteId){
      id=this.siteId;
    }
    else{
      id = this.route.snapshot.paramMap.get('id');
    }
    
    this.getViewModel(id,true);
  }

  saveModel() {
    this.editform.saveModel();
  }

  sitemaploaded = false;
  tabSelectionChanged(event) {
    // Get the selected tab
    //let selectedTab = event.tab;
    console.log(event);
    let index = event.index;
    if (index == 1) {
      if (!this.dashboardVisible) {
        this.dashboardVisible = true;
      }
      return;
    }
    if (index == 2) {
      if (!this.sitemaploaded) {
        this.mapVisible = true;
          this.sitemaploaded = true;
/*         setTimeout( () => {
          this.mapVisible = true;
          this.sitemaploaded = true;
        },200); */
               
      }
      return;
    }
    if (index == 3 && this.site3DURL!==null) {
        this.map3dVisible = true;
      return;
    }

    
  }

  site3DURL:any;
  site3DFrame:any= '<iframe class="w-100" src="[[site3DURL]]" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';;
  configure3D(site){
    let site3D:any=this.site.info["site3DURL"]
    if (site3D!=null && site3D.length>0){
      this.site3DURL=site3D;
      this.site3DFrame='<iframe class="frame3d" width="100%" height="100%" src="[[site3DURL]]" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'.replace("[[site3DURL]]",site3D);
    }   
    else{
       this.site3DURL=null;
    } 
  }

}
